import { useEffect, useState } from "react";
import DataGrid from '../../components/common/dataGrid/dataGrid';
import ButtonWithSearch from '../../components/common/buttonWithSearch';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import PrimarySideBar from '../../components/common/sideBar/primarySideBar';
import InputIterator from '../../components/common/inputIterator';
import AddImageSection from '../../components/common/AddImageSection';
import AddButtonSection from '../../components/common/AddButtonSection';
import { campFormRender, CampsListTableColumns } from "../../utils/serviceData";
import { commonPostApi, commonGetApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from '../../components/common/toast';
import { fetchOptions, dateFormat, orderObj, generateColumnMetadata } from "../../utils/utils";
import "./Camps.scss";
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { SORT_ORDER } from "../../constants/sortOrder";


const CampList = () => {
  const navigate = useNavigate();
  let organizationId = useSelector((state) => state?.common?.organization?.organization_id || state?.common?.organization?.value)
  const [loading, setLoading] = useState(true);
  const [column, setColumn] = useState([]);
  const [row, setRow] = useState([]);
  const [addCampVisible, setAddCampVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [uploadedImg, setUploadedImg] = useState({});
  const [formRender, setFormRender] = useState(campFormRender);
  const [campDetails,SetcampDetails]=useState([]);
  const { control, formState: { errors, dirtyFields }, handleSubmit, reset, setValue,trigger } = useForm({mode: "onChange",reValidateMode: "onChange"});
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "camp_name",
    sortDir: SORT_ORDER.ASC,
    sortFields: [["camp_name", SORT_ORDER.ASC]],
    searchCriteria: { searchvalue: "", organization_id: undefined },
  });
  


  const init = async (nav = navigator) => {
    setLoading(true);
    const currentObj = {
      query: {
        page: nav?.page,
        limit: nav?.rows,
        sortFields: nav?.sortFields,
        searchCriteria: {
          ...(nav?.searchCriteria || {}),
          organization_id: organizationId ?? nav?.searchCriteria?.organization_id,
        },
      },
    };
    try {
    const [data, organization, camptype,campdetailsData] = await Promise.all([
        commonPostApi(API_ENDPOINTS.CAMP_DETAILS, currentObj),
        commonGetApi(API_ENDPOINTS.GET_DASHBOARD_ORGANIZATION),
        commonGetApi(API_ENDPOINTS.CAMP_TYPE),
        commonGetApi(API_ENDPOINTS.GET_ALL_NOTIFICATION_CAMPS)
      ]); 

      setFormRender((prev) =>
        prev.map((formInput) => {
          if (formInput?.name === "organization_id") {
            return {
              ...formInput,
              options:
              
                organization?.data?.data?.map?.((org) => ({
                  ...org,
                  label: org?.organization_name,
                  value: org?.organization_id,
                })) || [],
            };
          } else if (formInput?.name === "camp_type_id") {
            return {
              ...formInput,
              options:
                camptype?.data?.data?.map?.((org) => ({
                  ...org,
                  label: org?.camp_type_name,
                  value: org?.camp_type_id,
                })) || [],
            };
          } else return formInput;
        })
      );
      SetcampDetails(campdetailsData?.data?.data);

      const userData = data?.data?.data || [];
      setColumn(
        orderObj(
          [
            "camp_name",
            "camp_code",
            "start_date",
            "end_date",
            "camp_type_name",
            "frequency_name",
            "city",
          ],
          generateColumnMetadata({
            data: userData,
            alias: {
              camp_name: "name",
              camp_code: "id",
              start_date: "start",
              end_date: "end",
              camp_type_name: "type",
              frequency_name: "freq",
              city: "location",
            },
            defaultColumnsArr:CampsListTableColumns
          })
        )
      );
      setRow(userData);
      setNavigator((prev) => ({
        ...prev,
        totalRecords: data?.data?.total || 0,
        page: data?.data?.currentPage || 1,
      }));
    } catch (e) {
      setColumn([]);
      setRow([]);
    } finally {
      setLoading(false);
    }
  };

  const initiateForm = () => {
    fetchOptions("CAMP_FREQUENCY", (frequency) => {
      setFormRender((prev) =>
        prev.map((item) => {
          if (item?.name === "frequency") return { ...item, options: frequency };
          else return item;
        })
      );
    });
  };

  const onSortClick = (event) => {
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    const newNav = {
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    };
    setNavigator(newNav);
    init(newNav);
  };

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };

  function onPageChange(event) {
    const newNav = {
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    };
    setNavigator(newNav);
    init(newNav);
  }

  const onRowClick = (event) => {
    const camp = event?.data;

    // if (!camp) return;
    // dispatch(updateCamp(camp));
    navigate(`/camp/${camp?.camp_details_id}`);
  };

  const onSubmit = async (data) => {
    if (loader) return;
    setLoader(true);
    if (uploadedImg?.size > 800 * 1024) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.FILE_SIZE_EXCEEDED);
      setLoader(false);
      return;
    }
    let headers = { "Content-Type": "application/json" };
    const addCamp = {
      ...data,
      start_date: dateFormat(data["start_date"]),
      end_date: dateFormat(data["end_date"]),
    };
    let finalData = addCamp;
    if (uploadedImg && uploadedImg.size && uploadedImg.size > 0) {
      finalData = new FormData();
      finalData.append("profile_picture", uploadedImg);
      finalData.append("_payload", JSON.stringify(addCamp));
      headers = {
        "Content-Type": "multipart/form-data",
      };
    } else {
      headers = {
        "Content-Type": "application/json",
      };
    }
    await commonPostApi(API_ENDPOINTS.ADD_CAMP_DETAILS, finalData, { headers })
      .then((resp) => {
        if (resp?.message) {
          showToast(TOAST_TYPE.ERROR, resp?.message);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.CAMP.ADDED);
          setAddCampVisible(false);
          init(navigator);
          reset();
          setLoader(false);
        }
      })
      .catch(() => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const handleSearchChange = (value) => {
    const newNav = {
      ...navigator,
      searchCriteria: { ...navigator.searchCriteria, searchvalue: value, organization_id: organizationId },
      page: 1,
      first: 0,
    };
    setNavigator(newNav);
    init(newNav);
  };

  useEffect(() => {
    if (!organizationId) return;
    const baseNav = {
      ...navigator,
      searchCriteria: { ...navigator.searchCriteria, organization_id: organizationId },
      page: 1,
      first: 0,
    };
    setNavigator(baseNav);
    initiateForm();
    init(baseNav);
  }, [organizationId]);

   useEffect(() => {
     if (!campDetails?.length) return;

     setFormRender((prev) =>
       prev.map((field) => {
         if (field.name === "camp_name") {
           return {
             ...field,
             rules: {
               ...field.rules,
               validate: (value) => {
                 const exists = campDetails.some(
                   (camp) =>
                     camp?.camp_name?.toLowerCase().trim() ===
                     value?.toLowerCase().trim()
                 );

                 return exists ? "Camp Name already exists" : true;
               },
             },
           };
         }
         return field;
       })
     );
     trigger("camp_name")
   }, [campDetails,trigger]);

  useEffect(() => {
    if (addCampVisible && organizationId) {
      setValue("organization_id", organizationId);
    }
  }, [addCampVisible, organizationId, setValue]);

  return (
    <div className="container">
      <DataGrid
        header={
          <ButtonWithSearch
            buttons={[{
              type: "primarySuccessButton",
              label: "Add Camp",
              icon: "pi pi-plus",
              class: "mt-2 w-full flex pr-4",

              onClick: () => {
                setAddCampVisible(true);
                if (organizationId) setValue("organization_id", organizationId);
              }
            }]}
            searchHeaderLable={"Camps"}
            searchPlaceHolder={"Search Camps"}
            isSearchEnabled={true}
            isCalenderEnabled={false}
            isButtonEnabledLeft={false}
            isButtonEnabledRight={true}
            styles={{ gridTemplateColumns: "1fr 400px" }}
            onChange={handleSearchChange}
          />
        }
        onSortClick={onSortClick}
        onPageChange={onPageChange}
        onRowCountChange={onRowCountChange}
        onRowClick={onRowClick}
        isPaginatorEnabled={true}
        navigator={navigator}
        column={column}
        value={row}
        loading={loading}
        sortable
      />
      {addCampVisible && (
        <PrimarySideBar
          visible={addCampVisible}
          onHide={() => {
            reset();
            setUploadedImg({});
            setAddCampVisible(false);
          }}
          header={<div className="sideBar-header">Add Camp</div>}
        >
          <AddImageSection showImg={uploadedImg} setImg={setUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={formRender}
          />
          <div className="pt-3">
            <AddButtonSection
              disabled={loader}
              buttons={[
                {
                  type: "primarySuccessButton",
                  label: "Submit",
                  class: "col-4",
                  disabled: Object.keys(dirtyFields).length === 0 || loader,
                  onClick: handleSubmit(onSubmit),
                },
                {
                  type: "primaryCancelButton",
                  label: "Cancel",
                  class: "col-4",
                  onClick: () => {
                    reset();
                    setUploadedImg({});
                    setAddCampVisible(false);
                  },
                }
              ]}
            />
          </div>
        </PrimarySideBar>
      )}
    </div>
  );
};

export default CampList;


